import { HttpUtil } from './HttpUtil'
import { HtmlUtil } from './HtmlUtil'
import { IWXPayParams } from 'kuaidong-model'

const _window = window as any

export class WechatUtil {
  protected wxInstance: any

  constructor(wxInstance: any) {
    this.wxInstance = wxInstance
  }

  public static availableApiList: string[] = []

  public static _instance: WechatUtil

  public static async getInstance(): Promise<WechatUtil> {
    if (this._instance) {
      return this._instance
    }

    const wxJS = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'

    await HtmlUtil.asyncAppendScript(wxJS)

    const jsApiList = [
      'updateAppMessageShareData', // 分享到朋友圈
      'onMenuShareWechat',
      'updateTimelineShareData',
      'onMenuShareTimeline', // 分享到朋友圈
      'onMenuShareAppMessage', // 分享到朋友
      'onMenuShareQQ', // 分享到qq
      'onMenuShareWeibo', // 分享到腾讯微博
      'onMenuShareQZone', // 分享到qq空间
      'chooseWXPay', // 微信支付
      'closeWindow', // 关闭界面
    ]

    const openTagList = ['wx-open-launch-app']

    const url = `https://api.tiantiantiaosheng.com/api/wx/jssdk?url=${encodeURIComponent(location.href)}`
    let config = (await HttpUtil.plainGet(url)) as any
    config = config.data as any
    config.jsApiList = jsApiList
    const wx = (window as any).wx

    wx.config({
      debug: false,
      appId: config.AppId,
      timestamp: config.timestamp,
      nonceStr: config.nonceStr,
      signature: config.signature,
      jsApiList: jsApiList,
      openTagList: openTagList,
    })

    return new Promise((resolve, reject) => {
      wx.ready(() => {
        this._instance = new WechatUtil(wx)
        wx.checkJsApi({
          jsApiList: [
            'updateAppMessageShareData', // 分享到朋友圈
            'updateTimelineShareData',
            'onMenuShareWechat',
            'onMenuShareTimeline', // 分享到朋友圈
            'onMenuShareAppMessage', // 分享到朋友
            'onMenuShareQQ', // 分享到qq
            'onMenuShareWeibo', // 分享到腾讯微博
            'onMenuShareQZone', // 分享到qq空间
          ], // 需要检测的JS接口列表
          openTagList,
          success: (res: any) => {
            this.availableApiList = Object.entries(res.checkResult)
              .filter((v) => v[1])
              .map((v) => v[0])
            resolve(this._instance)
          },
        })
      })
      wx.error((err: any) => {
        console.log(err)
        reject(err)
      })
    })
  }

  public async pay(params: IWXPayParams) {
    return new Promise((resolve, reject) => {
      this.wxInstance['chooseWXPay']({
        ...params,
        success: resolve,
        fail: reject,
      })
    })
  }

  public async close() {
    return this.wxInstance['closeWindow']()
  }

  public async setShareConfig(title: string, desc: string, imgUrl?: string, linkUrl?: string) {
    if (!linkUrl) {
      linkUrl = location.href
    }

    if (!imgUrl) {
      imgUrl = 'https://www.tiantiantiaosheng.com/icon_512.png'
    }

    const shareInfo = {
      title,
      desc,
      link: linkUrl,
      imgUrl,
      success: () => {
        // noop
        // console.log('set share success')
      },
      fail: (err: any) => {
        console.log(err)
      },
    }

    WechatUtil.availableApiList.map((v) => {
      this.wxInstance[v]?.(shareInfo)
    })
  }

  public static ensureBridgeIsReady() {
    return new Promise<void>((resolve, reject) => {
      if (_window.WeixinJSBridge) {
        resolve()
      } else {
        document.addEventListener('WeixinJSBridgeReady' as any, resolve)
      }

      setTimeout(() => {
        reject({ text: '请在微信客户端打开链接进行支付' })
      }, 2000)
    })
  }

  public static async pay(params: IWXPayParams) {
    await this.ensureBridgeIsReady()

    return new Promise((resolve, reject) => {
      _window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, (res: any) => {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          resolve(true)
        } else {
          reject({ text: '支付失败' })
        }
      })
    })
  }
}
